import { type SolutionDerivedTag, type SolutionId } from '../types/cache-tags';

const getSolutionDerivedTags = (solutionId: SolutionId): SolutionDerivedTag[] => [
  { type: 'SolutionHomeOverview', id: solutionId },
  { type: 'ImportedData', id: solutionId },
  { type: 'ChargingHubs', id: solutionId },
  { type: 'ChargingHubDetails', id: solutionId },
  { type: 'DepotMapMarkers', id: solutionId },
  { type: 'VehiclePolylines', id: solutionId },
];

export default getSolutionDerivedTags;
